<app-public-navigation
  [style.display]="shouldHideTopbar ? 'none' : null"
  [menuItems]="arrayMenu"
  [isAuthenticate]="isAuthenticate"
  [nameMenu]="nameMenu"
  [showManagerSwitch]="canAccessManager"
  [moodleUrl]="moodleUrl"
  [themeClass]="divClass"
  [navClass]="navClass"
  (geoBosquesClick)="irVisorGeoBosques()"
  (loginClick)="utilService.link('inicio-sesion')"
  (managerClick)="irGestor()"
  (logoutClick)="cerrarSesion()"
></app-public-navigation>
<div
  class="topbar-public-spacer"
  [class.topbar-public-spacer--visible]="shouldShowSpacer"
  aria-hidden="true"
></div>